import { applyMiddleware, createStore } from "redux";
import checkStockOut from "./middleware/checkStockOut";
import checkMultiAdd from "./middleware/multiAddChecker";
import rootReducer from "./rootReducer";

const store = createStore(rootReducer, applyMiddleware(checkMultiAdd, checkStockOut));

export default store;
